import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
const StyledTypography = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'clamp'
})(({ clamp }) => (Object.assign({}, (clamp && {
    display: '-webkit-box',
    WebkitLineClamp: clamp.toString(),
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
}))));
export default StyledTypography;
